import React from "react";
import { styled } from "@mui/material/styles";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import PauseCircleOutlineIcon from "@mui/icons-material/PauseCircleOutline";

const CardBox = styled("div")(({ isactive, status }) => {
    const statusColors = {
        BANK_DOCUMENT_VERIFIED: "#2E7D32",
        BANK_DOCUMENT_RECEIVED: "#ED6C02",
        BANK_DOCUMENT_REJECTED: "#D32F2F",
        BANK_DOCUMENT_ON_HOLD: "rgb(176, 126, 39)",
        TOTAL: "#1976d2",
    };

    const activeColor = statusColors[status] || "#1976d2";

    return {
        height: 120,
        width: "100%",                 // take full grid width
        borderRadius: 12,
        backgroundColor: "#fff",
        border: `2px solid ${isactive ? activeColor : "#E2E8F0"}`,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        padding: "16px",
        gap: "8px",
        cursor: "pointer",
        transition: "all 0.25s ease-in-out",
        position: "relative",
        boxShadow: isactive
            ? `0px 4px 14px ${activeColor}33`
            : "0px 2px 6px rgba(0,0,0,0.06)",

        "&:hover": {
            transform: "translateY(-3px)",
            boxShadow: `0px 6px 18px ${isactive ? `${activeColor}44` : "rgba(0,0,0,0.12)"
                }`,
        },
    };
});

const Title = styled("div")({
    fontSize: 13,
    fontWeight: 500,
    color: "#2A2E34",
});

const Count = styled("div")({
    fontSize: 20,
    fontWeight: 700,
    color: "#2A2E34",
});

const Desc = styled("div")({
    fontSize: 11,
    color: "#7B8794",
});

const StatusIcon = ({ status }) => {
    const style = { fontSize: 18 };

    switch (status) {
        case "BANK_DOCUMENT_VERIFIED":
            return <CheckCircleOutlineIcon style={{ color: "#2E7D32", ...style }} />;
        case "BANK_DOCUMENT_RECEIVED":
            return <HourglassEmptyIcon style={{ color: "#ED6C02", ...style }} />;
        case "BANK_DOCUMENT_REJECTED":
            return <CancelOutlinedIcon style={{ color: "#D32F2F", ...style }} />;
        case "BANK_DOCUMENT_ON_HOLD":
            return <PauseCircleOutlineIcon style={{ color: "#9C27B0", ...style }} />;
        default:
            return null;
    }
};

export default function BankStatusCard({
    title,
    count,
    description,
    status,
    onClick,
    isActive,
}) {
    return (
        <CardBox
            onClick={onClick}
            status={status}
            isactive={isActive}
        >
            <div style={{ position: "absolute", top: 10, right: 10 }}>
                <StatusIcon status={status} />
            </div>

            <Title>{title}</Title>
            <Count>{count}</Count>
            <Desc>{description}</Desc>
        </CardBox>
    );
}